import React, { useEffect, useState } from "react";

import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DoneIcon from '@mui/icons-material/Done'
import { red } from '@mui/material/colors';

import GPAP_Button, {GPAP_Button_light}  from "../../../../gpap-lib/Button_Collection";
import Loading from "../../components/LoadingTable";
import {action_list,action_update,closefilesubmission,files_view} from '../../../service/apis';
import auth from '../../../service/Auth';

import { Link } from "react-router-dom";
import { Redirect } from 'react-router-dom'
import ReactTable from "react-table";

import ExperimentDeletionReport from "../components/ExperimentDeletionReport";

const ActionPage = (props) => {

    const [headers, setHeaders] = useState([]);
    const [data, setData] = useState([]);
    const [dataSelected, setDataSelected] = useState("unselected");
    const [errorSelected, setErrorSelected] = useState("");    
    const [goToExperiments, setGoToExperiments] = useState(false);
    const [dialogDeletedExperiments, setDialogDeletedExperiments] = useState(false); 
    const [experimentFiles, setExperimentFiles] = useState([]);
    const [errorApiRequest, setErrorApiRequest] = useState("");
    const [loadData, setLoadData] = useState(true);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    
                
    useEffect(() => {  
        
        // 1. Get the number of experiments for every experiment
        const getExperimentFiles = async (experiments) => {
            const promises = [];
            let expList = Object.keys(experiments);
            let dataQuery = { "page": 1, "pageSize": 1, "fields": ["file_name"]};
            expList.forEach((exp) => {
                dataQuery["filtered"] = [{id:"ExperimentID", value:[exp]}];
                const result = files_view(auth.getToken(),config.api_endpoint, JSON.stringify(dataQuery));
                promises.push(result);
            });
            // Collect Promises
            const results = await Promise.all(promises);
            // Recover Promises
            const promiseList = results.map((result) => result.json());
            const expFiles = [];
            for (const promise of promiseList) {
                expFiles.push(await promise);
            }
            setExperimentFiles(expFiles.map( (item, index) => ({ "experiment": expList[index], "nFiles": item["_meta"]["total_items"] })));
            setLoadData(false);
        }

        let actionTableHeaders = [
            { label: "Experiment ID" , key: "experiment"},
            { label: "Local Experiment ID" , key: "LocalExperimentID"},
            { label: "Action", key: "action" },
            { label: "Current Value", key: "current" }
        ];
        
        //Query Api according to the action selected
        let queryUrl = "";
        switch (props.location.action) {
            case 'closeFileSubmission':
                setData(["close"]);
                setLoadData(false);
                break;
            case 'deleteExperiment':
                actionTableHeaders[3].label = "Status";
                getExperimentFiles(props.location.experiments);
                setData(["Delete experiments without submitted files", "Force delete experiments with files"]);
                break;
            case 'shareWithGroups':
            case 'unShareWithGroups':
                queryUrl="grouplist";
                break;
            case 'shareWithProject':
            case 'unShareWithProject':
                queryUrl="projectlist";
                break;
        }
        setHeaders(actionTableHeaders);
    
        if (queryUrl !== ""){
            /*Perform get action list*/
            action_list(auth.getToken(),config.api_endpoint,queryUrl)
            .then((response) => {
                    return response.json()
            })
            .then((dataApi) => {
                setData(dataApi);
                setLoadData(false);
            })
        }  
    },[]);

    useEffect(() => {
        getDataColumnTable();
    },[data, experimentFiles]);
    
    /*Get Action Name*/
    const getActionName = () => { return props.location.actions.find(item => item.value === props.location.action).name; }

    // Get Action Title
    const getTitle = () => {
        if ( props.location.action === "deleteExperiment" ) {
            return <Typography variant={"h5"} align={"center"}> Select experiments to delete </Typography>;
        } else {
            return <Typography variant={"h5"} align={"center"}> Experiments to apply the action {getActionName()}: </Typography>;
        }
    }
    
    const getDataColumnTable = () => {
        //Translates API Data result to data and columns for react-table
        setColumns(headers.map(header => { return {"Header":header.label, "accessor": header.key} } ));
        //Build data to render on react-table
        const action = getActionName();
        let rowItems = [];
        Object.entries(props.location.experiments).forEach(([experiment, info]) => {
            let currentValue = "";
            switch (props.location.action) {
                case 'closeFileSubmission':
                    currentValue = info.file_submission_close.toString();
                    break;
                case 'deleteExperiment':
                    // Get numbe of files per experiment
                    let expFiles = experimentFiles.find(item => item.experiment === experiment);
                    if (typeof expFiles !== "undefined") {
                        // Update value
                        if (info.file_submission_close) {
                            currentValue = "Submission complete. Can not be deleted.";
                        }
                        else if (expFiles.nFiles > 0) {
                            currentValue = "File Submission in progress. Can be deleted.";
                        }
                        else {
                            currentValue = "No files submitted. Can be deleted.";
                        }
                    }                    
                    break;
                case 'shareWithGroups':
                case 'unShareWithGroups':
                    currentValue = info.sharedGroups;
                    break;
                case 'shareWithProject':
                case 'unShareWithProject':
                    currentValue = info.projects;
                    break;
                case 'shareWithAllRdConnect':
                    currentValue = info.postembargo.toString();
                    break;
            }
            rowItems.push({"experiment":experiment,"LocalExperimentID": info.LocalExperimentID, "action":action,"current":currentValue});  
        });
        setRows(rowItems);  
    }

    const getLabelActionSelectTitle = () => {
        /*According to e action selected return the apropiate selector title*/
        if ( props.location.action === "shareWithGroups" || props.location.action === "unShareWithGroups" ){
            return "Groups";
        }
        else if( props.location.action === "shareWithProject" || props.location.action === "unShareWithProject" ){
            return "Projects";
        }
        else if( props.location.action === "closeFileSubmission" ) {
            return "Close";
        }
        else if( props.location.action === "closeFileSubmission" || props.location.action === "deleteExperiment"  ) {
            return "Mode";
        }
    }

    /*Handler Action Select click*/
    const handleSelectChange = (event) => {
        setDataSelected(event.target.value);
        setErrorSelected("");
    }
    
    /*Handle Apply Click Button*/
    const applyOnClick = async (request) => {
        /*1. Check valid Check box*/
        if (dataSelected !== "unselected" || props.location.action === "shareWithAllRdConnect"){
            /*2. CallAPI for update or remove groups / projects / share with all RDConnect*/
            /*Check Method*/
            let queryUrl,method;
            /*Get Experiment List*/
            let experiments = [];
            for (let experiment of Object.entries(props.location.experiments)){
                if (experiment[1]) experiments.push(experiment[0]);
            }
            /*Configure url an type of API request*/
            switch (props.location.action) {
                case "shareWithGroups":
                    method = "POST";
                    queryUrl = "editexperimentgroup/?experiments=" + experiments.join(',') + "&group=" + dataSelected;
                    break;
                case "unShareWithGroups":
                    method = "DELETE";
                    queryUrl = "editexperimentgroup/0/?experiments=" + experiments.join(',') + "&group=" + dataSelected;
                    break;
                case "shareWithProject":
                    method = "POST";
                    queryUrl = "editexperimentproject/?experiments=" + experiments.join(',') + "&project=" + dataSelected;
                    break;
                case "unShareWithProject":
                    method = "DELETE";
                    queryUrl = "editexperimentproject/0/?experiments=" + experiments.join(',') + "&project=" + dataSelected;
                    break;
                case "shareWithAllRdConnect":
                    method = "POST";
                    queryUrl = "shareallrdconnect/?experiments=" + experiments.join(',');
                    break;
                case "closeFileSubmission":
                    method = "POST";
                    queryUrl = "closefilesubmission"
                    break;
                case "deleteExperiment":
                    method = "DELETE";
                    queryUrl = "deleteownerexperiments/0/?experiments=" + experiments.join(',');
                    if (dataSelected.toLowerCase().includes("force")) queryUrl += "&force=true";
                    break;
            }
            /*Define API POST Request*/
            setLoadData(true);
            let response = ""; 
            if (queryUrl === "closefilesubmission") {
                let body = {"experiments_close": experiments};
                response = await closefilesubmission(auth.getToken(),config.api_endpoint,JSON.stringify(body));
            } else {
                response = await action_update(auth.getToken(),config.api_endpoint,queryUrl,method);
            }
            /*Check Status*/
            if (response.status !== 200){
                let errorMessage = await response.text().then(text => {return text;});
                setErrorApiRequest(errorMessage.replaceAll('"', ''));
                setLoadData(false);
            }
            else{
                if (props.location.action == "deleteExperiment") {
                    // Open delete Experiments Dialog
                    setDialogDeletedExperiments(true);
                    setLoadData(false);
                } else {
                    // Modify state to jump again to experiments
                    setGoToExperiments(true);
                    setLoadData(false);
                }                
            }
        }
        else{
            /*1.1 Print Red Error Message*/
            setErrorSelected("Not a valid option selected!!");
        }
    }
    
    
    const getOptionsSelectBox = () => {
        return(
            data.map((item, key) => {  
                let valueMenu = "";
                if ( props.location.action === "shareWithGroups" || props.location.action === "unShareWithGroups" || 
                     props.location.action === "closeFileSubmission" || props.location.action === "deleteExperiment") {
                    valueMenu = item;
                } else if ( props.location.action === "shareWithProject" || props.location.action === "unShareWithProject" ) {
                    valueMenu = item["project_title"]; 
                }
                return <MenuItem key={key} value={valueMenu}>{valueMenu}</MenuItem>;
            })
        );
    }
    
    const getSelectBox = () => {
        /*Get Select Box If needed*/
        return (
            <FormControl fullWidth>
                    <InputLabel id="select-action-label">{getLabelActionSelectTitle()}</InputLabel>
                    <Select
                        labelId="select-action-label"
                        id="select-action"
                        value={dataSelected}
                        label="Actions"
                        onChange={handleSelectChange}
                        sx={{ maxHeight: 35, minWidth: 200 }}
                    >
                        <MenuItem value='unselected'>----</MenuItem>      
                        {getOptionsSelectBox()}
                    </Select>
            </FormControl>
        );
    }
    
    const getDataKeys = () => {
        /*Get Key Returned by API for the case og groups (name) and projects (title)*/
        if ( props.location.action === "shareWithGroups" || props.location.action === "unShareWithGroups" ){
            return "name";
        }
        else if( props.location.action === "shareWithProject" || props.location.action === "unShareWithProject" ){
            return "project_title";
        }
    }

    const closeExperimentDeletionReport = () => {
        // Close Dialog Experiment Deletion Report
        setDialogDeletedExperiments(false);
        setGoToExperiments(true);
    };
    
    /* Go to Experiments View */
    if (goToExperiments){
        return <Redirect to={{pathname:'/experiments'}}/>;
    }

    return(
        <div className={"mainContent"}>
            {getTitle()}
            
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
            >
                <Grid item>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={1}
                        sx={{m:1}}
                    >
                        <Grid item>     
                            <Link to={props.location.next} style={{ textDecoration: 'none' }}>
                                <GPAP_Button_light id="goBack" startIcon={<ArrowBackIcon/>}>BACK</GPAP_Button_light>
                            </Link>
                        </Grid>
                        <Grid item> 
                            {/*Get Setelect Box if needed*/}
                            {getSelectBox()}
                        </Grid>
                        <Grid item>
                            <GPAP_Button id="apply" onClick={applyOnClick} startIcon={<DoneIcon/>}>APPLY</GPAP_Button>
                        </Grid>
                        <Grid item>
                            { /*Data error Message*/ }
                            { errorSelected !== "" ?
                                <Typography variant={"h5"} sx={{color:red[900]}}> 
                                    {errorSelected}
                                </Typography>   
                                :null
                            }
                            { /*Data Connect Message*/ }
                            { errorApiRequest !== "" ?
                                <Typography variant={"h5"} sx={{color:red[900]}}> 
                                    {errorApiRequest}
                                </Typography> 
                                :null
                            }  
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ReactTable
                        data={rows}
                        filterable
                        columns={columns}
                        defaultPageSize = {10}
                        pageSizeOptions = {[100, 200, 300]}
                        className="-striped -highlight"
                        loading={loadData}
                        LoadingComponent={Loading}
            />
            <ExperimentDeletionReport open={dialogDeletedExperiments} onClose={closeExperimentDeletionReport} 
                                      experiments={Object.entries(props.location.experiments)}/>
        </div>
    );
}

export default ActionPage;
